// extracted by mini-css-extract-plugin
export default {"askQuestionTopText":"Y2-z","yourQuestionLabel":"Z2-z","notAuthedMessage":"_2-z","form":"a3-z","textarea":"b3-z","error":"c3-z","disabled":"d3-z","edited":"e3-z","submit":"f3-z"};